import { ISummaryTableDataNode } from 'components/common/SummaryTable/SummaryTable.properties';

const schema: ISummaryTableDataNode[] = [
    {
        objectName: 'ProductReceiptSummary',
        isLoading: 'productReceiptLoading',
        title: '',
        children: [
            {
                label: 'Product',
                fieldNames: [
                    'ProductIdDisplay',
                    'ProductIdDisplayLabel'
                ],
                valueRenderer: {
                    hyperLink: {
                        link: false,
                        menu: true
                    },
                    api: {
                        api: '/inventoryEnquiry/lookup/action',
                        name: 'enquiry',
                        params: {
                            queryFields: {
                                ProductId: 'ProductId',
                                SearchText: 'ProductIdDisplay'
                            }
                        }
                    }
                }
            },
            {
                label: 'Product Group',
                fieldNames: [
                    'ProductGroup',
                    'ProductGroupLabel',
                ],
            },
            {
                label: 'Extended Description',
                fieldNames: [
                    'ExtendedDescription',
                ],
            },
            {
                label: 'Warehouse',
                fieldNames: [
                    'WarehouseEntity',
                    'WarehouseEntityDescription'
                ],
            },
            {
                label: 'Available',
                fieldNames: [
                    'AvailableInWarehouseDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Elsewhere',
                fieldNames: [
                    'AvailableElsewhereDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Cost',
                fieldNames: [
                    'DisplayCostDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Base',
                fieldNames: [
                    'BasePriceDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'GP',
                fieldNames: [
                    'GrossPercentageDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Sell/Unit',
                fieldNames: [
                    'SellPerUnitIncTaxAmountDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Sell/Units\n (EX.Tax)',
                fieldNames: [
                    'SellPerUnitExTaxAmountDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: '',
                labelStyles: { backgroundColor: '#fff' },
                fieldNamesStyles: { backgroundColor: '#fff', padding: 0 },
                fieldNames: [
                    ''
                ],
            },
        ]
    },
];

export default schema;
